module.exports = __webpack_public_path__ + "img/icon_tt_new_on.13299c45.svg";